export const SUPPORTED_LANGS = ["en", "fr", "da", "de"] as const;

export type Lang = (typeof SUPPORTED_LANGS)[number];

export const LANG_LABELS: Record<Lang, string> = {
  en: "English",
  fr: "Français",
  da: "Dansk",
  de: "Deutsch",
};

export function isSupportedLang(lang: string | undefined): lang is Lang {
  return !!lang && (SUPPORTED_LANGS as readonly string[]).includes(lang);
}

export function normalizeLang(lang: string | undefined): Lang {
  return isSupportedLang(lang) ? lang : "en";
}